import type { ReactNode } from "react";

export function AppFrame({ children }: { children: ReactNode }) {
  return (
    <div className="app-frame" data-app-frame>
      <div className="app-frame-surface">{children}</div>
    </div>
  );
}
